import React from 'react';

function Portfolio() {
  return (
    <section className="work-grid pt-60 pb-60">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="item mb-80 mt-40">
              <div className="img">
                <img src="/assets/imgs/portfolio/qatalys/qatalys-cover.png" alt="Qatalys" />
              </div>
              <div className="cont d-flex align-items-end mt-30">
                <div>
                  <span className="p-color mb-5 sub-title">Brand, Website</span>
                  <h6>Qatalys</h6>
                </div>
                <div className="ml-auto">
                  <a href="/project-details">
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="item mb-80 mt-40">
              <div className="img">
                <img src="/assets/imgs/portfolio/kaar/kaar-workshop.jpg" alt="Kaar" />
              </div>
              <div className="cont d-flex align-items-end mt-30">
                <div>
                  <span className="p-color mb-5 sub-title">Brand</span>
                  <h6>Kaar</h6>
                </div>
                <div className="ml-auto">
                  <a href="/project-details">
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 offset-lg-2">
            <div className="item mb-80 mt-40">
              <div className="img">
                <img src="/assets/imgs/portfolio/yoku/yoku-cover.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-end mt-30">
                <div>
                  <span className="p-color mb-5 sub-title">Brand, Web Design</span>
                  <h6>Yoku</h6>
                </div>
                <div className="ml-auto">
                  <a href="/project-details">
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 d-flex align-items-end">
            <div className="item mb-80 mt-40">
              <div className="img">
                <img src="/assets/imgs/portfolio/motogalaxy/moto-cover.png" alt="Moto Galaxy" />
              </div>
              <div className="cont d-flex align-items-end mt-30">
                <div>
                  <span className="p-color mb-5 sub-title">Brand</span>
                  <h6>Moto-Galaxy</h6>
                </div>
                <div className="ml-auto">
                  <a href="/project-details">
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-2">
            <div className="item mb-80 mt-40">
              <div className="img">
                <img src="/assets/imgs/portfolio/explora/explora-cover.png" alt="" />
              </div>
              <div className="cont d-flex align-items-end mt-30">
                <div>
                  <span className="p-color mb-5 sub-title">Brand</span>
                  <h6>Explora</h6>
                </div>
                <div className="ml-auto">
                  <a href="/project-details">
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
